function Fourohfour() {
  return <div>Page not found</div>
}

export default Fourohfour;
